import cx from 'classnames'
import React from 'react'

import SearchBar from '@cinch/oxd-containers/global-search-bar/src'
import { isIOS } from '@cinch/oxd-utils/browser-support/src'

import Scrim from './components/scrim'
import styles from './site-search.module.css'

export interface Props {
  children: (searchComponent: React.ReactNode) => React.ReactNode
  isOpen: boolean
  toggleOpenState: (isOpen: boolean) => any
}

const SiteSearch: React.FC<Props> = ({ children, isOpen, toggleOpenState }) => {
  const [isSearchMounted, mountSearch] = React.useState<boolean>(false)
  const [isSearchVisible, setSearchVisibility] = React.useState<boolean>(false)
  const [isIOSHidden, updateIOSHidden] = React.useState<boolean>(false)

  const onSearchCloseAnimationEnd = () => {
    mountSearch(false)
    toggleOpenState(false)
  }

  const onSearchClose = () => {
    setSearchVisibility(false)
  }

  React.useEffect(() => {
    setSearchVisibility(isSearchMounted)
  }, [isSearchMounted])

  React.useEffect(() => {
    if (isOpen) {
      mountSearch(true)
    } else {
      onSearchClose()
    }
  }, [isOpen])

  React.useEffect(() => {
    if (!isSearchMounted && isIOS()) {
      updateIOSHidden(true)
    } else if (isIOSHidden && isSearchMounted) {
      updateIOSHidden(false)
    }
  }, [isSearchMounted])

  return (
    <div
      className={cx({
        [styles.siteSearchHidden]: isIOSHidden,
        [styles.siteSearch]: isSearchMounted,
      })}
    >
      <Scrim isVisible={isSearchVisible} onClick={onSearchClose} />
      {(isSearchMounted || isIOS()) && (
        <div className={styles.siteSearchContent}>
          {children(
            <SearchBar
              isOpen={isSearchVisible}
              onClose={onSearchClose}
              formName="site-search"
              onExit={onSearchCloseAnimationEnd}
            />,
          )}
        </div>
      )}
    </div>
  )
}
export default SiteSearch
